import React, { useEffect, useRef, useState } from 'react';
import styles from './ReferenceLink.module.scss';
import {
  apiDeleteRequestFile,
  apiUpdateRequestFiles,
  apiUploadRequestFiles,
} from '../../helpers/api';
import { useSelector } from 'react-redux';
import { requestsSelector } from '../../redux/slicers/requestSlicer';
import cx from 'classnames';
import { isValidUrlV2 } from '../../screens/Requests/Sections/helper';
import icons from '../../assets';

function RefrenceLink({ title, links, setLinks, linkType, isReadOnly , handlefetchLink=() => {} }) {
  const [linkId, setLinkID] = useState(1);
  const PREFIX = 'https://';
  const dataRef = useRef();
  const _requestSelector = useSelector(requestsSelector);
  const { RequestInfo } = icons;

  useEffect(() => {
    handlefetchLink?.()
    if (!links?.length) {
      setLinks([{ id: 1, value: '' }])
    }
    return (() => {
      setLinks([])
    })
  }, [_requestSelector?.activeTab])
  
  const handleChange = (value, _id) => {
    if (isReadOnly) return;
    const _links = links.map((item) => {
      if (item.id === _id) item['value'] = value.slice(PREFIX.length);
      return item;
    });

    const notEmptyLinks = _links.filter((_item) => _item.value);
    const emptyLinks = _links.filter((_item) => !_item.value && _item.actual_id);

    emptyLinks.forEach(async (_link) => {
      await apiDeleteRequestFile(_link.actual_id);
    });

    if (notEmptyLinks.length) {
      setLinks(notEmptyLinks);
      dataRef.current = notEmptyLinks;
    } else setLinks([{ id: 1, value: '' }]);
  };

  const handleAddClick = () => {
    if (isReadOnly) return;
    const _links = links.filter((item) => item.value);
    setLinks([..._links, { id: linkId + 1, value: '' }]);
    dataRef.current = [..._links, { id: linkId + 1, value: '' }];
    setLinkID(linkId + 1);
  };

  const handleEnterPress = (e) => {
    if (e.keyCode === 13) {
      handleAddClick();
      e.target.blur();
    }
  };

  const handleBlur = (e, _value, links) => {
    if (_value && !isValidUrlV2(_value)) {
      e.target.classList.add(styles.invalidLink);
      e.target.parentNode.classList.add(styles.invalidLinkWrapper);
    } else {
      handleAddOrUpdateRefLink(links);
    }
  };

  const handleAddOrUpdateRefLink = async (urlObject) => {
    if (dataRef.current?.length) {
      if (urlObject?.value && !urlObject?.actual_id) {
        const formData = new FormData();
        formData.append('file_type', linkType);
        formData.append('three_d_model_request', _requestSelector.currentRequestId);
        isValidUrlV2(urlObject?.value) &&
          !urlObject.actual_id &&
          formData.append('link', `https://${urlObject.value}`);
        await apiUploadRequestFiles(formData);
        formData.delete('link');
      }

      if (urlObject?.value && isValidUrlV2(urlObject?.value) && urlObject?.actual_id) {
        const _formData = new FormData();
        _formData.append('file_type', linkType);
        _formData.append('three_d_model_request', _requestSelector.currentRequestId);
        _formData.append('link', `https://${urlObject?.value}`);
        await apiUpdateRequestFiles(urlObject.actual_id, _formData);
      }
    }
  };

  const handleFocus = (e) => {
    e.target.classList.remove(styles.invalidLink);
    e.target.parentNode.classList.remove(styles.invalidLinkWrapper);
  };

  const handleUpdateLinkAPI = async () => {
    if (dataRef.current?.length) {
      if (
        dataRef.current.filter((item) => item.value && isValidUrlV2(item.value) && !item.actual_id)
          ?.length
      ) {
        const formData = new FormData();
        formData.append('file_type', linkType);
        formData.append('three_d_model_request', _requestSelector.currentRequestId);
        dataRef.current.forEach(
          (item) =>
            item.value &&
            isValidUrlV2(item.value) &&
            !item.actual_id &&
            formData.append('link', `https://${item.value}`)
        );
        await apiUploadRequestFiles(formData);
        formData.delete('link');
      }

      if (
        dataRef.current.filter((item) => item.value && isValidUrlV2(item.value) && item.actual_id)
          .length
      ) {
        dataRef.current.map(async (item) => {
          if (item.value && isValidUrlV2(item.value) && item.actual_id) {
            const _formData = new FormData();
            _formData.append('file_type', linkType);
            _formData.append('three_d_model_request', _requestSelector.currentRequestId);
            _formData.append('link', `https://${item.value}`);
            await apiUpdateRequestFiles(item.actual_id, _formData);
          }
        });
      }
    }
  }

  return (
    <div className={styles.wrapper}>
      <h6>{title}</h6>
      {links.map((link) => (
        <div key={link.id}>
          <input
            placeholder={PREFIX}
            type="text"
            key={link.id}
            value={PREFIX + link.value.replace(PREFIX, '').replace('http://','')}
            onChange={(e) => handleChange(e.target.value, link.id)}
            className="w-100 position-relative"
            onKeyDown={handleEnterPress}
            onBlur={(e) => handleBlur(e, link.value, link)}
            onFocus={handleFocus}
            readOnly={isReadOnly}
          />
          <div className={styles.invalidPlaceholder}>
            <RequestInfo /> Invalid Link
          </div>
        </div>
      ))}

      {!isReadOnly ? (
        <div className={cx(styles.addLink, !links.at(-1)?.value && styles.disabled)}>
          <span onClick={handleAddClick}>+ Add a link</span>
        </div>
      ) : null}
    </div>
  );
}

export default RefrenceLink;
